import { singletonScriptState } from '@/utils/window/SingletonScriptState';
import { API_GET_ONE_CATEGORY_SELECT_SUCCESS, API_GET_ONE_CATEGORY_SUCCESS, } from '../actions/CategoryActions';
/** プロフィールの初期値はScriptタグから読み込む */
const INITIAL_STATE = singletonScriptState.categories.value || {};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { payload, type }) => {
    switch (type) {
        case API_GET_ONE_CATEGORY_SUCCESS:
        case API_GET_ONE_CATEGORY_SELECT_SUCCESS: {
            return Object.assign(Object.assign({}, state), payload);
        }
        default: {
            return state;
        }
    }
};
